import { createClient } from "@supabase/supabase-js";

// Client Supabase — schéma public uniquement
// Les données métier sont accessibles via les RPC avec tenant_id
// Plus besoin de REACT_APP_SUPABASE_SCHEMA
export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_KEY
);